import FestivalCards from "@features/landing/components/common/Cards/layout";
import FestivalCategoriesSlider from "../common/CategoriesSlider";
import FestivalHero from "../common/hero";

import FestivalCategoriesSkeleton from "../common/CategoriesSkeleton";
import { FESTIVAL_TYPE, FestivalProps } from "@features/landing/types";
import FestivalFooter from "../common/footer";

const WonderFestival: React.FC<FestivalProps> = ({ festivalData }) => {
  const festival = festivalData?.data?.festival;
  const categories = festivalData?.data?.categories ?? [];

  const {
    type = FESTIVAL_TYPE.WONDER,
    title = "",
    slug = "",
    special_text: specialText = "",
    discount_text: discountText,
    footer_description: footerHTML,
    time_period,
  } = festival || {};

  const expireTime = time_period?.expire_at ?? 0;

  const hasCategories = categories.length > 0;

  return (
    <>
      <FestivalHero
        theme={type}
        title={title}
        expireDate={expireTime}
        specialText={specialText}
        discountText={discountText}
      />
      {Boolean(hasCategories) ? (
        <FestivalCategoriesSlider data={categories} />
      ) : (
        <FestivalCategoriesSkeleton />
      )}
      <FestivalCards slug={slug} />
      {footerHTML && <FestivalFooter theme={type} description={footerHTML} />}
    </>
  );
};

export default WonderFestival;
